interface DailyOrder {
  date: string;
  count: number;
  revenue: number;
}

interface DashboardDailyChartProps {
  dailyOrders: DailyOrder[];
  maxCount: number;
}

export default function DashboardDailyChart({ dailyOrders, maxCount }: DashboardDailyChartProps) {
  return (
    <div className="bg-white rounded-xl border border-border/60 p-5">
      <p className="text-sm font-semibold uppercase tracking-wider text-muted-foreground mb-4">
        Dnevne narudžbe
      </p>
      {dailyOrders.length === 0 ? (
        <div className="h-40 flex items-center justify-center text-sm text-muted-foreground">
          Nema podataka
        </div>
      ) : (
        <div className="flex items-end gap-1 h-40">
          {dailyOrders.map((day) => {
            const heightPct = Math.max((day.count / maxCount) * 100, 2);
            const parts = day.date.split("-");
            const label = `${parts[2]}.${parts[1]}`;
            return (
              <div
                key={day.date}
                className="flex flex-col items-center flex-1 min-w-[4px] h-full justify-end"
              >
                <div
                  className="bg-foreground/80 hover:bg-foreground rounded-t-sm w-full min-w-[4px] transition-all"
                  style={{ height: `${heightPct}%` }}
                  title={`${label}: ${day.count} narudžbi`}
                />
                <span className="text-[9px] text-muted-foreground mt-1 leading-none">
                  {label}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
